import { Fragment } from 'react'
import NextImage from 'next/image'

import { stepsItems } from './consts'
import classes from './steps.module.css'

export const Steps = () => {
  return (
    <div className={classes.stepsWrapper}>
      {stepsItems.map((el, idx) => (
        <Fragment key={el.title}>
          <div className={classes.step}>
            <NextImage
              src={el.icon}
              width={48}
              height={48}
              alt="benefit icon"
              className={classes.icon}
            />
            <div className={classes.stepTextWrapper}>
              <p className={classes.stepTitle}>Step {idx + 1}</p>
              <h3 className={classes.stepDescription}>{el.title}</h3>
              <p className={classes.text}>{el.subtitle}</p>
            </div>
          </div>
          {idx !== stepsItems.length - 1 && <div className={classes.separator} />}
        </Fragment>
      ))}
    </div>
  )
}
